import React from "react";
import Image from "next/image";

interface NextImageProps {
  src: string;
  alt: string;
  width?: number | `${number}`;
  height?: number | `${number}`;
  size?: string;
  style?: React.CSSProperties;
  className?: string;
  quality?: number | `${number}`;
  title?: string;
  priority?: boolean;
  loading?: "eager" | "lazy";
}

export const NextImage = ({
  src,
  width,
  height,
  alt,
  size,
  style,
  className,
  title,
  quality,
  priority,
  loading,
}: NextImageProps) => {
  return (
    <Image
      className={className}
      src={src}
      width={width}
      height={height}
      alt={alt}
      sizes={size}
      style={style}
      quality={quality}
      title={title}
      priority={priority}
      loading={loading || (priority ? "eager" : "lazy")}
    />
  );
};
